import { Observable } from 'rxjs/Observable'
import { DataService } from 'core/data/service'
import { pedidoBuilder } from '../../pages/checkout/checkout.builder'
import 'intl'
import 'intl/locale-data/jsonp/pt-BR.js';

export class CestaService extends DataService {
    constructor() {
        super()
        this.numberFormat = Intl.NumberFormat('pt-BR', {style:'currency', currency:'BRL'});
        this.imageDefault = 'https://cdn1.staticpanvel.com.br/produtos/15/default.jpg?ims=282x';
    }

    getCarrinho() {
      const options = {
          method: 'GET',
          url: '/carrinho'
      }

      return Observable
              .fromPromise(super.request(options))
              .map(res => pedidoBuilder(res));
  }

    removerItemNaCesta(itemObj) {
        const options = {
            method: 'DELETE',
            url: '/carrinho',
            data: this.buildItemRequest(itemObj)
        }

        return Observable
                .fromPromise(super.request(options))
                .map(res => pedidoBuilder(res));
    }

    atualizarItemNaCesta(itemObj) {
        const options = {
            method: 'PUT',
            url: '/carrinho/alterar',
            data: this.buildItemRequest(itemObj)
        }

        return Observable
                .fromPromise(super.request(options))
                .map(res => pedidoBuilder(res));
    }

    adicionarItemNaCesta(itemObj) {
        const options = {
            method: 'PUT',
            url: '/carrinho',
            data: this.buildItemRequest(itemObj)
        }

        return Observable
                .fromPromise(super.request(options))
                .map(res => pedidoBuilder(res));
    }

    adicionarItemNaCestaPbm(itemPbmRequest) {
        const options = {
            method: 'PUT',
            url: '/carrinho',
            data: itemPbmRequest
        }

        return Observable
                .fromPromise(super.request(options))
                .map(res => pedidoBuilder(res));
    }

    buildItemRequest(itemObj) {
        return {
            "idProduto": itemObj.codigoItem,
            "quantidade": itemObj.quantidade,
            "codigoOferta": itemObj.codigoOferta
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cesta/cesta.service.js